import React, { createContext, useContext, useState } from "react";
import { portalApplication } from "_graphql/queries/portal";
import { message } from "@centrate-io/barn";

const CustomerContext = createContext();

// Create a provider component
export const CustomerProvider = ({ children, client }) => {
  const [customer, setCustomer] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [applicationId, setApplicationId] = useState(null);
  const [appShortId, setAppShortId] = useState(null);
  // Load main application data
  const fetchCustomer = async (appId) => {
    try {
      setLoading(true);

      const customerData = await client.query({
        variables: { id: appId },
        query: portalApplication,
      });

      const app = customerData?.data?.portalApplication;
      if (!app) {
        message.error("Application not found");
        setLoading(false);
        return;
      }
      setApplicationId(app.id);
      setAppShortId(app.short_id);
      setCustomer(app);
      setLoading(false);
    } catch (err) {
      console.error(err);
      message.error("Error loading customer data");
      setLoading(false);
    }
  };

  const updateCustomer = (field, value) => {
    const updated = { ...customer };
    updated[field] = value;
    setCustomer(updated);
  };

  return (
    <CustomerContext.Provider
      value={{
        customer,
        loading,
        applicationId,
        appShortId,
        fetchCustomer,
        updateCustomer,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

// Custom hook to use the context
export const useCustomer = () => {
  return useContext(CustomerContext);
};
